<script lang="ts">
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';
    import { z } from 'zod';

    import { Warehouse } from './Warehouse';
    import { WarehousesElements } from './WarehousesElements';
    import { VehicleValidator } from '../Vehicles/VehicleValidator';
    import { VehiclesApi } from '../Vehicles/VehiclesApi';
    import { api } from '../../../stores/api';
    import IconExpander from '../../shared/Icons/IconExpander.svelte';
    import IconFlag from '../../shared/Icons/IconFlag.svelte';
    import InputText from '../../shared/InputText.svelte';
    import ButtonRemove from '../../shared/ButtonRemove.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import LinkSmallBlack from '../../shared/LinkSmallBlack.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import { WarehouseApi } from './WarehouseApi';
    import Abbreviation from '../../shared/Abbreviation.svelte';
    import SearchForm from '../../shared/SearchForm.svelte';
    import { beforeUpdate, onMount } from 'svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import { captureMessage } from '../../utilities/Sentry';
    import { openModal } from 'svelte-modals';
    import ModalRemoveSomething from '../Modals/ModalRemoveSomething.svelte';
    import TemplateErrorGroup from '../../shared/TemplateErrorGroup.svelte';
    import { WarehouseValidator } from './WarehouseValidator.js';
    import IconWarehouse from '../../shared/Icons/IconWarehouse.svelte';
    import { Umami } from '../../utilities/Umami';

    export let warehouse: Warehouse;
    export let warehousesElements: WarehousesElements;
    export let showHeader: boolean = true;
    export let expandedIndex: string = '';
    export let addMode: boolean = false;

    let expanded: boolean = false;
    let error: string = '';
    let errorDetails: string = '';
    let loading: boolean = false;
    let validated: boolean = true; // TODO: implement validation

    let mapObject: any = null;

    function toggleExpanded() {
        console.log('toggleExpanded');
        expandedIndex = expandedIndex === warehouse.innerId ? '' : warehouse.innerId;
        expanded = expandedIndex === warehouse.innerId || addMode;
    }

    function centerMap(x: number, y: number) {
        Targeo.Base.Map.zoomAndCenter({ x, y }, 20);
    }

    function removeWithConfirm() {
        openModal(ModalRemoveSomething, {
            text: $_('Are you sure you want to remove this warehouse?'),
            name: warehouse.getName(),
            onClick: () => {
                let id = warehouse.getId();
                if (id) {
                    WarehouseApi.removeOne(get(api), id)
                        .then(() => {
                            warehousesElements.remove(warehouse);
                            warehousesElements = warehousesElements;
                            Umami.event('warehouse_remove', { warehouse_id: id });
                        })
                        .catch(err => {
                            Umami.error('warehouse_remove', err, { warehouse_id: id });
                            error = $_('Cannot remove this warehouse');
                            errorDetails = err;
                        }).finally(() => {
                            warehousesElements.drawWarehouses();
                        });
                }
            },
        });
    }

    // function drawWarehouse() { // duplicated in WarehousesElements
    //     mapObject = new Targeo.MapObject.Label(
    //         {
    //             x: warehouse.getX(),
    //             y: warehouse.getY(),
    //         },
    //         warehouse.getAbbreviation() || '?',
    //         {
    //             fs: 15,
    //             fc: '#000000',
    //             fm: { b: true },
    //             bw: 1,
    //             bc: '#000000',
    //             bs: 'solid',
    //             br: 4,
    //             p: [1, 3, 1, 3],
    //             bgc: '#98c8f8',
    //         }
    //     );
    //     Targeo.Base.Map.UOAdd(mapObject);
    // }

    // function undrawWarehouse() {
    //     if (mapObject) {
    //         Targeo.Base.Map.UORemove(mapObject.id);
    //         mapObject = null;
    //     }
    // }

    onMount(() => {

        if (!warehouse.getAbbreviation()) {
            warehouse.calcAbbreviation(warehousesElements.getWarehouses());
        }

        // Promise.all([onMapReady()]).then(() => {
        //     drawWarehouse();
        // });

        // return () => {
        //     console.log('onDestroy, undrawWarehouse');
        //     undrawWarehouse();
        // };
    });

    beforeUpdate(() => {
        if (mapObject) {
            mapObject.setText(warehouse.getAbbreviation());
        }
    });

    $: expanded = expandedIndex === warehouse.innerId || addMode;

    $: validated = WarehouseValidator.validateAll(warehouse);

    function centerWarehouseOnMap() {
        if (warehouse.getX() && warehouse.getY()) {
            Targeo.Base.Map.zoomAndCenter(
                {
                    x: warehouse.getX(),
                    y: warehouse.getY(),
                },
                20
            );
        }
    }
</script>

{#if showHeader}
    <div class="list-element vehicle-header list-element-header">
        <div class="vehicle_icon"></div>
        <div class="name">{$_('Warehouse name')}</div>
        <div class="abbr">{$_('Abbr')}</div>
        <div class="warehouse-address">{$_('Address')}</div>
    </div>
{/if}

{#if !expanded}
    <div class="list-element vehicle-header list-element-data">
        <div
            class="vehicle_icon"
            on:click={() => {
                toggleExpanded();
            }}
        >
            <IconWarehouse scale={0.7} />
        </div>
        <div
            class="name"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {warehouse.getName()}
        </div>

        <div class="abbr" class:extended-background={expanded}>
            <Abbreviation text={warehouse.getAbbreviation()} on:click={centerWarehouseOnMap} />
        </div>

        <div
            class="warehouse-address"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {warehouse.getAddress()}
        </div>

        <div class="expand-trigger">
            <IconExpander
                isOpen={expanded}
                on:click={() => {
                    toggleExpanded();
                }}
            />
        </div>
    </div>
{/if}

{#if expanded}
    <div class="vehicle-expanded-container">
        <TemplateErrorGroup {error} {errorDetails}>
            <div class="vehicle-header">
                <div
                    class="vehicle_icon"
                    on:click={() => {
                        toggleExpanded();
                    }}
                >
                    <IconWarehouse scale={0.7} />
                </div>
                <div class="name">
                    <InputText
                        value={warehouse.getName()}
                        valid={WarehouseValidator.isNameValid(warehouse) === ''}
                        style="width: 100%"
                        on:change={event => {
                            if (event?.target) {
                                warehouse.setName(event?.target?.value || '').calcAbbreviation(warehousesElements.getWarehouses());
                                warehouse = warehouse;
                                if (!addMode) {
                                    warehousesElements.save(warehouse);
                                    warehousesElements = warehousesElements;
                                }
                            }
                        }}
                        on:keyup={event => {
                            warehouse.setName(event?.target?.value || '').calcAbbreviation(warehousesElements.getWarehouses());
                            warehouse = warehouse;
                        }}
                    />
                </div>
                <div class="abbr">
                    <Abbreviation
                        text={warehouse.getAbbreviation()}
                        on:click={centerWarehouseOnMap}
                    />
                </div>
                <div class="warehouse-address">
                    <SearchForm
                        placeholder={$_('address_or_coordinates')}
                        pointOnMap={false}
                        coords={warehouse.get().geom.coordinates || null}
                        validSearchResult={null}
                        label={warehouse.getAddress()}
                        on:set={evt => {
                            warehouse.get().geom.coordinates = [
                                evt.detail.coords.x,
                                evt.detail.coords.y,
                            ];
                            warehouse.get().details.query = evt.detail.query;
                            warehouse.get().details.city = evt.detail.item.place || '';
                            warehouse.get().details.street = evt.detail.item.street || '';
                            warehouse.get().details.house = evt.detail.item.number || '';
                            centerMap(warehouse.getX(), warehouse.getY());
                            if (mapObject) {
                                mapObject.setCoordinates(evt.detail.coords);
                            }
                            warehouse = warehouse;
                            if (!addMode) {
                                warehousesElements.save(warehouse);
                                warehousesElements = warehousesElements;
                            }
                        }}
                    />
                </div>

                <div class="expand-trigger">
                    {#if !addMode}
                        <IconExpander
                            isOpen={expanded}
                            on:click={() => {
                                toggleExpanded();
                            }}
                        />
                    {/if}
                </div>
            </div>
        </TemplateErrorGroup>

        {#if !addMode}
            <div style="padding: 20px;">
                <ButtonRemove on:click={removeWithConfirm} text={$_('remove_warehouse')} disabled={warehouse.hasAssignedVehicles()} title={(warehouse.hasAssignedVehicles() ? $_('warehouse_with_drivers_cannot_be_removed') : '')}/>
                <!--{#if error}-->
                <!--    <div-->
                <!--        style="width: 85%; display: flex; justify-content: flex-end; padding: 0 20px 5px 20px;"-->
                <!--    >-->
                <!--        <ErrorInline text={$_(error)} />-->
                <!--    </div>-->
                <!--{/if}-->
            </div>
        {/if}

        {#if addMode}
            <div
                style="display: flex; justify-content: flex-end; align-items: flex-end; padding: 20px;"
            >
                <!--{#if error}-->
                <!--    <div-->
                <!--        style="width: 85%; display: flex; justify-content: flex-end; padding: 0 20px 5px 20px;"-->
                <!--    >-->
                <!--        <ErrorInline text={$_(error)} />-->
                <!--    </div>-->
                <!--{/if}-->
                <div style="display: flex; align-items: center;column-gap: 30px;">
                    <span style="font-size: 14px;">
                        <LinkSmallBlack
                            text={$_('Cancel')}
                            on:click={() => {
                                addMode = false;
                            }}
                        />
                    </span>
                    <ButtonMain
                        text={$_('Add warehouse')}
                        disabled={loading || !validated}
                        on:click={() => {
                            error = '';
                            loading = true;
                            warehousesElements
                                .save(warehouse)
                                .then(() => {
                                    Umami.event('warehouse_add');
                                    addMode = false;
                                })
                                .catch(err => {
                                    Umami.error('warehouse_add', err);
                                    error = $_('Cannot save this warehouse');
                                    errorDetails = err;
                                })
                                .finally(() => {
                                    loading = false;
                                    warehousesElements = warehousesElements;
                                });
                        }}
                    />
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .vehicle-header {
        display: grid;
        grid-template-columns: 30px 0.7fr 50px 1fr 30px;
        grid-template-rows: auto;
        line-height: 20px;
        padding: 2px 0;
        /*background-color: #cfa516;*/
        grid-template-areas: 'vehicle_icon name abbr warehouse-address expand-trigger';
    }
    .vehicle-header .vehicle_icon {
        grid-area: vehicle_icon;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .vehicle-header .name {
        grid-area: name;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
        overflow: hidden;
        line-height: 20px;
    }
    .vehicle-header .abbr {
        grid-area: abbr;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vehicle-header .warehouse-address {
        grid-area: warehouse-address;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
        line-height: 20px;
        /*overflow: hidden;*/
    }
    .vehicle-header .expand-trigger {
        grid-area: expand-trigger;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .vehicle-expanded-container {
        background-color: var(--selected-item-background);
        /*background-color: #f92672;*/
    }
    .vehicle-expanded-container .vehicle-header {
        grid-template-rows: 41px;
    }
</style>
